module.exports = __webpack_public_path__ + "img/20220310_151020.327c6763.jpg";